export const SCHEDULING_PERMISSIONS = {
  read: 'scheduling.read',
  create: 'scheduling.create',
  update: 'scheduling.update',
  delete: 'scheduling.delete'
} as const;
